import React from "react";
import "./css/GradeBadge.scss";

/**
 * SMART5 / NOW 사업성 등급 뱃지
 * App.scss 의 .grade_* 색상과 함께 사용
 */
function GradeBadge({
  grade,
  className = "",
  as: Component = "div",
  emptyLabel = "N",
  emptyGradeClass = "default",
}) {
  const hasGrade = grade != null && String(grade).trim() !== "";
  const label = hasGrade ? String(grade) : emptyLabel;
  const gradeClass = `grade_${hasGrade ? grade : emptyGradeClass}`;

  return (
    <Component
      className={["grade-badge", gradeClass, className].filter(Boolean).join(" ")}
    >
      {label}
    </Component>
  );
}

export default GradeBadge;
